// src/config.js
const AppConfig = {
    title: "Failed….",
    paragraph: "Loading corrupted…",
    img: "https://i.postimg.cc/zBvTx8kx/IMG-6877.jpg",
    url: "failed",
    id: "8290926"
};

export default AppConfig;